module.exports = __webpack_public_path__ + "img/sheepy.e4cf1d04.svg";